const StatsShotsChartOptions = {
  ON_OFF: 'on/off',
  CONCEDED: 'conceded',
} as const;

export default StatsShotsChartOptions;
